const actions = {
  LOAD_DATA: 'INITIAL/LOAD_DATA',
}

export default actions